var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icons8_user_24px",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACi0lEQVRIDbVUS2gTURS9902alogVRSwmrb+dv0Lxg7ipKK24UHBRQdAYEULBhRu3iQ/iwo22oG6C0ARBEMFuuqjtxi5ciAhVaHFTwdDU6sYU0dKmmet50UAnMzEf0nAu9/POO3fevMllov//uq7qQ7aSG0LSx0Qd/9iL8JMFpZ4sjuhZxBWBPd5rBwe0fylgPxCiQTAsmBcKQvx4Z+vX2++TybwXwbOBEc8F7DFs6INVhTC92vpLXZh5oVfLyaq8YPJcQB7C1yQOHrHQ2dwmGTJxublO0BmJHRbhaRA9m6NeCQXcSXf5nbhFREWh4K6jWAWWJbbZ66C5hPC1nHEw6kmEXHtdDaDXBWsUu8s3ejVw3Uv5pnpyrwaZegTWc4XItde3nmBi/HEmmWQ/4u+wKVgt6AVpBxNNwDvgauAjO1kgvgnWNrbl/vzTxFvEFRGK6BMk9kUQ1oRVEt4B5ciQZNKJGWJ6hNAnikcxi44i9kRnWB8XsUex6GPi4YWU/oTYAZzKkReTI9Foy7eVjjG8rn4Ulok4zcIjK8s0K5t/c1u+9YBYfJ2ErmG9DZ/2+MIX6zy91mvIHfBsYBhmHm3YsDMNSoZXVBzXTNIvRPtMHX4OTzaB0VB1XBv+hhoexEP/lPYF99jnyOaTrPh5NqXN8HMRg+FYD5G6hAt+k83QeE13EIrEB3B5Q1ALwf5C6IMwv2OWjGDUKuJdeE3HsNgNK2GeWd2aT+mXpYLxjhMEw/E7zKSp8R/6SjybTtwtSVilIBSJRXDU4VLeoMcD8+n2nt7PP6enPhoNFIiCl/V25bfn0L7dFJtgS1Z+dW/m2b0fyohxSyHaRHEjucX2+aMmKDYg5ismaaoxhY3eH+6Qy37s6YFpAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.dd444a8bf489a2c817d14caa0a93e5d5.svg";
export { ForwardRef as ReactComponent };